import { useState, useContext } from "react";
import { UserContext } from "../../contexts/userProvider";
import PatrimonioCliente from "./Types/patrimonioCliente";
import StatusInstalacao from "./Types/statusInstalacao";
import FaturamentoAnexo from "./Types/faturamentoAnexo";
import TabNavigation from "../General/TabNavigation";

const Relatorios = () => {
  const { user } = useContext(UserContext);
  const [activeTab, setActiveTab] = useState("Patrimônio por cliente");

  const tabs = [
    {
      key: "Patrimônio por cliente",
      label: "Patrimônio por cliente",
      icon: "folder",
      content: <PatrimonioCliente />
    },
    {
      key: "Status da instalação",
      label: "Status da instalação",
      icon: "chart",
      content: <StatusInstalacao />
    }
  ];

  // Adiciona aba condicional baseada no nível do usuário
  if (user?.nivel === '3') {
    tabs.push({
      key: "Faturamento por anexo",
      label: "Faturamento por anexo",
      icon: "file",
      content: <FaturamentoAnexo />
    });
  }

  return (
    <div className="w-full min-h-full">
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="default"
      />
    </div>
  );
};

export default Relatorios;
